<script lang="ts">
  import { Col } from "sveltestrap";
  import { CardFooter, Step } from "../../../utils/Constant/Constant";
  import Card from "../Card.svelte";
</script>

<Col sm="12">
  <Card
    cardHeaderProps="pb-0 d-flex justify-content-between align-items-center"
    headerTitle="How to use it?"
    footercontent={CardFooter}
  >
    <div slot="custombody">
      <h5>{Step} 1</h5>
      <p>
        On this layout, First of all you have to add the class rtl attribute in
        body tag
      </p>
      <h5>{Step} 2</h5>
      <p>Contents are change right to left from left to right respectively</p>
      <h5>{Step} 3</h5>
      <p>
        when you want to change spacing left to right at that right left spacing
        you have to unset css and apply right spacing in css
      </p>
      <h5>{Step} 4</h5>
      <p>
        Sometimes js are not change directly with text-align css,so that time
        you have to copy js and change the class as rtl="true".
      </p>
    </div>
  </Card>
</Col>
